import React from 'react';
import './Speakers.css';
import VideoPresent from './VideoPresent/VideoPresent';
// import Nedin from '../../img/speakers/Nedin.png'
import uabnb from '../../img/speakers/uabnb.png'
// import Rivna from '../../img/speakers/Rivna.png'
// import uaants from '../../img/speakers/uaants.png'
// import Kalinchenko from '../../img/speakers/Kalinchenko.png'
// import BalanceInsider from '../../img/speakers/Balance Insider.png'
// import Marhel from '../../img/speakers/Marhel.png'
// import Muha from '../../img/speakers/Muha.png'
// import lestdoitukraine from '../../img/speakers/lestdoitukraine.png'
// import Tuljakova from '../../img/speakers/Tuljakova.png'
// import spivdija from '../../img/speakers/spivdija.png'
// import Severina from '../../img/speakers/Severina.png'
// import ukraineua from '../../img/speakers/ukraineua.png'
// import Sidorenko from '../../img/speakers/Sidorenko.png'
// import Kosikova from '../../img/speakers/Kosikova.png'
// import Pavlenko from '../../img/speakers/Pavlenko.png'
// import ukrposhta from '../../img/speakers/ukrposhta.png'
import Ostrovska from '../../img/speakers/Ostrovska.png'
import dnipro from '../../img/speakers/dnipro.png'
// import UHF from '../../img/speakers/UHF.png'
// import Veretilnyk from '../../img/speakers/Veretilnyk.png'
// import Skiba from '../../img/speakers/Skiba.png'
import Kovalko from '../../img/speakers/Kovalko.png'
import saveukraine from '../../img/speakers/saveukraine.png'
// import Rudneva from '../../img/speakers/Rudneva.png'
// import helpukraine from '../../img/speakers/helpukraine.png'
// import Turkovska from '../../img/speakers/Turkovska.png'
// import tylvolontera from '../../img/speakers/tylvolontera.png'
// import Pritula from '../../img/speakers/Pritula.png'
// import Bashkirov from '../../img/speakers/Bashkirov.png'
// import redcross from '../../img/speakers/redcross.png'
// import Krasilnikova from '../../img/speakers/Krasilnikova.png'
// import eastsos from '../../img/speakers/eastsos.png'
// import Vusjka from '../../img/speakers/Vusjka.png'
// import Yanchenko from '../../img/speakers/Yanchenko.png'
// import pryhistock from '../../img/speakers/pryhistock.png'
// import Sachenko from '../../img/speakers/Sachenko.png'
// import a21 from '../../img/speakers/a21.png'
// import Kominko from '../../img/speakers/Kominko.png'
// import saveukraine from '../../img/speakers/saveukraine.png'
// import Sikur from '../../img/speakers/Sikur.png'
// import Lysenko from '../../img/speakers/Lysenko.png'
// import poradnyk from '../../img/speakers/poradnyk.png'
// import Shkilnyk from '../../img/speakers/Shkilnyk.png'
// import Mykhailov from '../../img/speakers/Mykhailov.png'
// import Zdniprovska from '../../img/speakers/Zdniprovska.png'
// import zhivoedelo from '../../img/speakers/zhivoedelo.png'
// import Babyna from '../../img/speakers/Babyna.png'
// import Galezka from '../../img/speakers/Galezka.png'
// import Zhigariova from '../../img/speakers/Zhigariova.png'
// import style_wedding from '../../img/speakers/style_wedding.svg'
import Tupa from '../../img/speakers/Tupa.png'
import rotary from '../../img/speakers/rotary.png'
import Silanteva from '../../img/speakers/Silanteva.png'
import ASR from '../../img/speakers/ASR.png'
import Aristov from '../../img/speakers/Aristov.png'
import revival from '../../img/speakers/revival.png'
import Ivanenko from '../../img/speakers/Ivanenko.png'
import patient from '../../img/speakers/patient.png'
import Fedorov from '../../img/speakers/Fedorov.png'
import lvivklaster from '../../img/speakers/lvivklaster.png'
import Kyrilovich from '../../img/speakers/Kyrilovich.png'
import upaw from '../../img/speakers/upaw.png'
import Kozura from '../../img/speakers/Kozura.png'
import IPM from '../../img/speakers/IPM.png'
import Podolyak from '../../img/speakers/Podolyak.png'
import pritula_logo from '../../img/speakers/pritula_logo.png'
import Chevganuk from '../../img/speakers/Chevganuk.png'
import uaanimals from '../../img/speakers/uaanimals.png'
import Zatvarskyi from '../../img/speakers/Zatvarskyi.png'
import djmelyk from '../../img/speakers/djmelyk.png'
import Losik from '../../img/speakers/Losik.png'
import azou from '../../img/speakers/azou.png'

export default class SpeakersList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            list: [
                {
                    photo: Kovalko,
                    panel: 'Гуманітарна допомога',
                    name: 'Мартин Ковалко',
                    position: `Співорганізатор ініціативи SaveUkraine.city`,
                    fb: 'https://www.facebook.com/martyn.kovalko',
                    logo: saveukraine,
                },
                {
                    photo: Ostrovska,
                    panel: 'Ліки',
                    name: 'Ганна Островська',
                    position: `Медсестра. Інструктор з тактичної та невідкладної допомоги. Була бойовим медиком.`,
                    fb: 'https://www.facebook.com/profile.php?id=100004292238017',
                    logo: dnipro,
                },
                {
                    photo: Tupa,
                    panel: 'Фандрейзинг',
                    name: 'Оксана Тюпа',
                    position: `ГО "Ротарі Клуб Київ Інтерернешенал". Офіцер дистрикту з фандрейзингу. Голова ГО`,
                    fb: 'https://www.facebook.com/oxana.tiupa',
                    logo: rotary,
                },
                {
                    photo: Silanteva,
                    panel: 'Гуманітарна допомога',
                    name: 'Інна Силантьєва',
                    position: `Президент Асоціації соціального розвитку через право, провідний фахівець Центру проблем імплементації Європейського соціального права Інституту права КНУ імені Тараса Шевченка`,
                    fb: 'https://www.facebook.com/inna.silantieva',
                    logo: ASR,
                },
            ],
            listHide: [
                {
                    photo: Aristov,
                    panel: 'Ліки',
                    name: 'Вадим Арістов',
                    position: `Лікар, стратегічний консультант. Директор Revival Institute. Засновник глобальної медичної ініціативи StingMD. Архітектор стандартизованих мед. списків Lifevest-5, Preventable Losses, Sieged Chronic, якими користуються волонтери і міжнародні організації`,
                    logo: revival,
                },
                {
                    photo: Ivanenko,
                    panel: 'Ліки',
                    name: 'Інна Іваненко',
                    position: `Виконавча директорка Благодійного фонду "Пацієнти України"`,
                    fb: 'https://www.facebook.com/inna.boyko.37',
                    logo: patient,
                },
                {
                    photo: Fedorov,
                    panel: 'Військова амуніція',
                    name: 'Юрій Федоров',
                    position: `Член правління ГО "Львівський Оборонний Кластер" - найбільший український проект з виробництва бронежилетів. Директор ТОВ "Харківський завод засобів індивідуального захисту" - виробник бронежилетів та спорядження, в т.ч. для потреб МОУ та країн НАТО`,
                    fb: 'https://www.facebook.com/uv.fedorov',
                    logo: lvivklaster,
                },
                {
                    photo: Kyrilovich,
                    panel: 'Тварини',
                    name: 'Ольга Кирилович',
                    position: `Співзасновник ГО "Світова асоціація з питань тварин України"`,
                    fb: 'https://www.facebook.com/olga.kirilovich',
                    logo: upaw,
                },
                {
                    photo: Kozura,
                    panel: 'Військова амуніція',
                    name: 'Андрій Козюра',
                    position: `Експерт з тактичного спорядження`,
                    inst: 'https://instagram.com/endrunot?igshid=YmMyMTA2M2Y=',
                    logo: IPM,
                },
                {
                    photo: Podolyak,
                    panel: 'Військова амуніція',
                    name: 'Меланія Подоляк',
                    position: `Волонтерка Благодійного фонду Сергія Притули`,
                    fb: 'https://www.facebook.com/podolyakmel',
                    logo: pritula_logo,
                },
                {
                    photo: Chevganuk,
                    panel: 'Тварини',
                    name: 'Ольга Чевганюк',
                    position: `Співзасновниця громадської організації UAnimals`,
                    fb: 'https://www.facebook.com/olga.chevganiuk',
                    logo: uaanimals,
                },
                {
                    photo: Zatvarskyi,
                    panel: 'Військова амуніція',
                    name: 'Іван Затварський',
                    position: `Волонтерський екіпаж оперативного реагування "Джмелик"`,
                    fb: 'https://www.facebook.com/jonathan.zatvarski',
                    logo: djmelyk,
                },
                {
                    photo: Losik,
                    panel: 'Тварини',
                    name: 'Алла Лосік',
                    position: `Віце-Президент Асоціації Зоозахисних Організацій України АЗОУ`,
                    fb: 'https://www.facebook.com/alla.losik',
                    logo: azou,
                },
            ]
            // list: [
            //     {
            //         photo: Yanchenko,
            //         name: 'Галина Янченко',
            //         position: `Народний депутат, ініціатор проєкту "Прихисток"`,
            //         title: 'Прихистки - ситуація в Україні',
            //         abstract: `???`,
            //         logo: pryhistock,
            //     },
            //     {
            //         photo: Sachenko,
            //         name: 'Юлія Саченко',
            //         position: `Голова правління А21 Україна`,
            //         title: 'Як не потрапити в трудове та сексуальне рабство?',
            //         abstract: `???`,
            //         logo: a21,
            //     },
            //     {
            //         photo: Zdniprovska,
            //         name: `Алла Задніпровська`,
            //         position: `СЕО та засновник Міжнародної Консалтингової Групи «Живе Діло»`,
            //         title: 'Волонтерство. Життєстійкість. Як підтримувати себе та інших',
            //         abstract: `???`,
            //         logo: zhivoedelo,
            //     },
            //     {
            //         photo: Mykhailov,
            //         name: `Святослав Михайлов`,
            //         position: `Адвокат`,
            //         title: 'Компенсація за знищене житло, допомога безробітним і кримінальна відповідальність чоловіків, які тікають від війни. Юридичні новини',
            //         abstract: `???`,
            //     },
            // ],
            // listHide: [
            //     {
            //         photo: Kominko,
            //         name: 'Комінко Оксана',
            //         position: `Керівник проекту "Гості"`,
            //         title: 'Що таке проєкт "Гості" та як з ним можно співпрацювати прихисткам?',
            //         abstract: `???`,
            //         logo: saveukraine,
            //     },
            //     {
            //         photo: Sikur,
            //         name: 'Ольга Сікур',
            //         position: ``,
            //         title: 'Барселона, Іспанія. Підримка та прихисток для українців',
            //         abstract: `???`,
            //     },
            //     {
            //         photo: Lysenko,
            //         name: `Дар'я Лисенко`,
            //         position: `Проєктна менеджерка, юристка БФ "Право на захист", координаторка проєкту "Юридичний порадник для ВПО"`,
            //         title: 'Як отримати довідку ВПО та які пільги вона допомагає отримати? Допомога міжнародних організацій для ВПО',
            //         abstract: `???`,
            //         logo: poradnyk,
            //     },
            //     {
            //         photo: Babyna,
            //         name: `Анастасія Бабина`,
            //         position: ``,
            //         title: 'Чехія. Підтримка та прихисток для українців',
            //         abstract: `???`,
            //     },
            //     {
            //         photo: Galezka,
            //         name: `Олександра Галецька`,
            //         position: ``,
            //         title: 'Німеччина. Підтримка та прихисток для українців',
            //         abstract: `???`,
            //         logo: style_wedding,
            //     },
            //     {
            //         photo: Zhigariova,
            //         name: `Олена Жигарьова`,
            //         position: `Солістка гурту On I Ona`,
            //         title: 'Грузія. Підтримка та прихисток для українців',
            //         abstract: `???`,
            //     },
            // ],
        //     listOld: [
        //     {
        //         id: 7,
        //         photo: Tuljakova,
        //         name: 'Ірина Тулякова',
        //         position: `Керівниця Співдії`,
        //         title: 'Як співдіяти заради перемоги',
        //         abstract: `???`,
        //         logo: spivdija,
        //     },
        //     {
        //         id: 5,
        //         photo: Marhel,
        //         name: 'Юлія Мархель',
        //         position: `Координаторка Міжнародного проєкту гуманітарної допомоги Let's do it Ukraine SOS, лідерка Letsdoitukraine.org`,
        //         title: 'Рекрутмент та мотивація волонтерів',
        //         abstract: `???`,
        //         logo: lestdoitukraine,
        //     },
        //     {
        //         id: 9,
        //         photo: Rudneva,
        //         name: 'Ольга Руднєва',
        //         position: `Керівниця фонду Олени Пінчук та волонтерка HelpUkraine Center`,
        //         title: 'Робота логістичного хабу на прикладі HelpUkraine Center',
        //         abstract: `???`,
        //         logo: helpukraine,
        //     },
        //     // {
        //     //     id: 8,
        //     //     photo: Severina,
        //     //     name: 'Анна Северіна',
        //     //     position: `Куратор волонтерської організації "Ukraine Alive 2022", керівник відділу логістики`,
        //     //     title: 'Волонтери – хто вони?',
        //     //     abstract: `???`,
        //     //     logo: ukraineua,
        //     // },
        //     {
        //         id: 8,
        //         photo: Kovalko,
        //         name: 'Мартин Ковалко',
        //         position: `Співорганізатор ініціативи SaveUkraine.city`,
        //         title: "Довіра - валюта волонтерів",
        //         abstract: `???`,
        //         logo: saveukraine,
        //     },
        //     {
        //         id: 1,
        //         photo: Ostrovska,
        //         name: 'Ганна Островська',
        //         position: `Медсестра. Інструктор з тактичної та невідкладної допомоги. Була бойовим медиком`,
        //         title: 'Як правильно працювати з ліками',
        //         abstract: `???`,
        //         logo: dnipro,
        //     },
        //     {
        //         id: 3,
        //         photo: Veretilnyk,
        //         name: 'Альона Веретільник',
        //         position: `Керівник у відділі евакуації у UHF`,
        //         title: 'Організація процесу евакуації',
        //         abstract: `???`,
        //         logo: UHF,
        //     },
        //     // {
        //     //     id: 9,
        //     //     photo: Sidorenko,
        //     //     name: 'Аліна Сидоренко',
        //     //     position: `Керівник складів волонтерської організації Ukraine Alive 2022`,
        //     //     title: 'Ефективна робота складів',
        //     //     abstract: `???`,
        //     //     logo: ukraineua,
        //     // },
        //     // {
        //     //     two: 'true',
        //     //     id: 10,
        //     //     photo: Pavlenko,
        //     //     name: 'Ігор Смілянський',
        //     //     name2: 'Юлія Павленко',
        //     //     position: `Генеральний директор АТ «УКРПОШТА»`,
        //     //     position2: `Директорка департаменту міжнародних операцій АТ «УКРПОШТА»`,
        //     //     title: 'Міжнародні відправлення під час війни',
        //     //     abstract: `???`,
        //     //     logo: ukrposhta,
        //     // },
        //     // {
        //     //     id: 9,
        //     //     photo: Kosikova,
        //     //     name: 'Євгенія Косікова',
        //     //     position: `Куратор волонтерської організації Ukraine Alive 2022`,
        //     //     title: 'Робота з заявками. Як не налажати',
        //     //     abstract: `???`,
        //     //     logo: ukraineua,
        //     // },
        //     // {
        //     //     id: 3,
        //     //     photo: Kalinchenko,
        //     //     name: 'Олександр Калінченко',
        //     //     position: 'Засновник UA.Ants',
        //     //     title: 'Тема уточнюється',
        //     //     abstract: `???`,
        //     //     logo: uaants,
        //     // },
        //   ],
        //   listHideOld: [
        //     {
        //         id: 4,
        //         photo: Skiba,
        //         name: 'Дарина Скиба',
        //         position: `Заступниця президента ГО “Let’s do it, Ukraine”`,
        //         title: "Логістика гуманітарної допомоги на території України",
        //         abstract: `???`,
        //         logo: lestdoitukraine,
        //     },
        //     {
        //         id: 6,
        //         photo: Muha,
        //         name: 'Олександра Муха',
        //         position: `Міжнародна комунікація та логістика гуманітарної допомоги Let'd do it Ukraine SOS, CEO Schoolrecyclingworld.org в Україні`,
        //         title: 'Логістика гуманітарної допомоги: міжнародна документація',
        //         abstract: `???`,
        //         logo: lestdoitukraine,
        //     },
        //     {
        //         id: 2,
        //         photo: Rivna,
        //         name: 'Тетяна Рівна',
        //         position: 'Balance Insider, засновник Громадської Організації',
        //         title: 'Організаційна структура волонтерської організації',
        //         abstract: `???`,
        //         logo: BalanceInsider,
        //     },
        //     {
        //         id: 10,
        //         photo: Turkovska,
        //         name: 'Зоя Турковська',
        //         position: `Керівник проекту #ТилВолонтера, магістр психології, гештальт-терапевт`,
        //         title: 'Як волонтерам тримати себе в ресурсі',
        //         abstract: `???`,
        //         logo: tylvolontera,
        //     },
        //     {
        //         id: 11,
        //         photo: Pritula,
        //         name: 'Володимир Притула',
        //         position: `Куратор напрямку логістичних перевезень`,
        //         title: 'Логістика гуманітарної допомоги, факапи і лайфхаки',
        //         abstract: `???`,
        //     },
        //     {
        //         id: 12,
        //         photo: Krasilnikova,
        //         name: 'Юлія Красільникова',
        //         position: `Виконавча директорка Благодійного фонду Восток SOS`,
        //         title: 'Робота волонтерів у гарачих точках: доставка гуманітарної допомоги та евакуація',
        //         abstract: `???`,
        //         logo: eastsos,
        //     },
        //     {
        //         id: 13,
        //         two: 'true',
        //         photo: Bashkirov,
        //         name: 'Костянтин Башкіров',
        //         name2: 'Тетяна Зима',
        //         position: `Голова Харківського Червоного Хреста`,
        //         position2: `Голова Харківського Червоного Хреста`,
        //         title: 'Гуманітарна допомога та ліки. Як волонтери можуть співпрацювати з організацією Червоного Хреста',
        //         abstract: `???`,
        //         logo: redcross,
        //     },
        //     {
        //         id: 14,
        //         photo: Vusjka,
        //         name: 'Олена Вузька',
        //         position: `Операційна директорка Української Волонтерської Служби`,
        //         title: 'Волонтерський рух в Україні ',
        //         abstract: `???`,
        //         logo: UVS,
        //     },
        //   ],
        }
      }

    render() {
        return (
            <div className="speakers" id='speakers'>
                <div className="container">
                    <h3>Спікери Саміту</h3>
                    <VideoPresent speakers={this.state.list} speakersHide={this.state.listHide}/>
                </div>
            </div>
        );
    }
};